import { StarIcon } from "constants/icons";
import React from "react";
import PropTypes from "prop-types";
import "components/StarRatings/StarRatings.css";

//Shows user ratings.
function StarRatings({
  userRatings,
  onClick = Function.prototype,
  totalRatings = 5,
}) {
  let iterator = Array(totalRatings).fill("");

  return (
    <div className="star-ratings">
      {iterator.map((star, index) => (
        <i
          className={index >= userRatings ? "" : "filled-star"}
          onClick={onClick.bind(null, index + 1)}
          key={index}
        >
          <StarIcon key={star} />
        </i>
      ))}
    </div>
  );
}

StarRatings.propTypes = {
  userRatings: PropTypes.number.isRequired,
  totalRatings: PropTypes.number,
  onClick: PropTypes.func,
};

export default StarRatings;
